'use client';

import { UpdateAlert } from '@/components/update-alert';
import { useServiceWorker } from '@/hooks/useServiceWorker';

export default function UpdatePrompt() {
    const { updateAvailable, updateApp } = useServiceWorker();

    return <UpdateAlert show={updateAvailable} onUpdate={updateApp} />;
}

